import React, { useEffect, useState } from 'react';
import './style.scss';
import classNames from 'classnames';
import { ItemMessageComponent } from './item-message';
import { ItemHelperComponent } from './item-helper';
import { useSelector } from 'react-redux';
import { IRootState } from '../../../store/reducers';
import { getLogout } from '../../../api';
import { jumpToLogin, onToHomePage } from '../../lib';
import { isConsoleRoute } from '../../game-content/lib';
import InGame from '../../../assets/svg/logo.svg';
import InGameWhiteN from '../../../assets/svg/logo-n-white.svg';
import InGameSupport from '../../../assets/svg/logo-support.svg';
import { ItemSiteSwitchComponent } from './item-site-switch';
import { AccountCenter } from '../../user/account-center';
import { useHistory } from 'react-router-dom';
import { ItemUserComponent } from './item-user';
import { getLocationSearchParam } from '../../../lib';
import { GlobalNotification } from '../global-notification';
import { isSupportSystem } from '../../../config';
import { supportLogout } from '../../admin/lib/ioa-helper';
import { SupportSwitchComponent } from './support-site-switch';
import { ItemTimeSwitchComponent } from './item-time-switch';

interface IProps {
  readonly fixedMenu?: boolean;
  readonly isHoverLeftSide?: boolean;
  readonly renderGameFilterNode?: React.ReactNode;
  readonly isTransparent?: boolean;
  readonly isSmallLogo?: boolean;
}

export const Header = (props: IProps) => {
  const history = useHistory();
  const userInfo = useSelector((state: IRootState) => state.common.userInfo);
  const [showAccountCenter, setShowAccountCenter] = useState<boolean>(false);

  const isConsole = isConsoleRoute();

  useEffect(() => {
    initialization();
  }, []);

  const initialization = () => {
    initShowDefaultAccountCenter();
  };

  // notice: this is one time display
  // current user account center not page view, it is modal pop
  // need compatible with enter from website scenes, because account center undefined router
  // current website source referer only exist param (show-account-center), so replace root pathname
  const initShowDefaultAccountCenter = () => {
    const showAccountCenter = !!getLocationSearchParam('show-account-center');
    if (showAccountCenter) {
      setShowAccountCenter(showAccountCenter);
      history.replace('/');
    }
  };

  const onLogout = async () => {
    if (isSupportSystem()) {
      supportLogout();
      return true;
    }
    const res = await getLogout();
    if (res) {
      jumpToLogin();
    }
    return !!res;
  };

  const onAccountCenter = async () => {
    setShowAccountCenter(true);
  };

  const renderRightActions = () => {
    return (
      <div className="col-right">
        <ul className="header-actions">
          {isSupportSystem() ? (
            <SupportSwitchComponent />
          ) : (
            <>
              <ItemTimeSwitchComponent />
              <ItemSiteSwitchComponent />
              <ItemHelperComponent />
              <ItemMessageComponent />
            </>
          )}
          {userInfo ? (
            <ItemUserComponent
              userInfo={userInfo}
              onLogout={onLogout}
              onAccountCenter={onAccountCenter}
            />
          ) : null}
        </ul>
      </div>
    );
  };

  const renderAccountCenter = () => {
    if (showAccountCenter && userInfo) {
      return (
        <AccountCenter
          userInfo={userInfo}
          onClose={() => setShowAccountCenter(false)}
        />
      );
    }
    return null;
  };

  const getLogoSrc = () => {
    let logoSrc = InGame;
    if (
      location.pathname === '/studio/select-studio' ||
      location.pathname === '/'
    ) {
      logoSrc = InGameWhiteN;
    } else if (window.location.hostname.includes('support')) {
      logoSrc = InGameSupport;
    }
    return logoSrc;
  };

  const renderLogo = () => {
    const logoSrc = getLogoSrc();
    return (
      <div
        className={classNames('ingame-bg-box', {
          'is-transparent': props.isTransparent,
          'is-small-logo': props.isSmallLogo,
        })}
      >
        <img
          src={logoSrc}
          className="ingame-bg"
          onClick={onToHomePage}
          style={{
            width: logoSrc === InGameWhiteN ? '36px' : '',
            height: logoSrc === InGameWhiteN ? '36px' : '',
          }}
        />
      </div>
    );
  };

  const renderPortal = () => {
    return (
      <div className="col-title">
        {isConsole ? props.renderGameFilterNode : <div></div>}
      </div>
    );
  };

  const className = classNames('gc-header', {
    'fixed-menu': props.fixedMenu,
    'is-console': isConsole,
    'is-hover': props.isHoverLeftSide,
  });

  const isNeedShowFullHead = /studio\/\d+\/organization/.test(
    location.pathname
  );

  return (
    <div
      className={classNames('gc-page-headline', {
        ['gc-page-headline-full']: isNeedShowFullHead,
      })}
    >
      <GlobalNotification />
      <div className={className}>
        {!isConsole && renderLogo()}
        {renderPortal()}
        {renderRightActions()}
        {renderAccountCenter()}
      </div>
    </div>
  );
};
